import React, { useState, useEffect } from 'react';
import { Input, Modal, ModalBody } from '@windmill/react-ui';
import LabelArea from 'components/form/LabelArea';
const BillApprovalDetails = ({
	isOpen,
	onClose,
	title = 'Approval Details',
	handleSubmit, // This function should accept (selectedAmounts, remainingAmount, selectedIds)
	billAmount,
	data = [],
	customClass = '',
}) => {
	const [remarks, setRemarks] = useState('');
	const [selectedAmounts, setSelectedAmounts] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]); // New state to hold checkbox IDs
	const [totalAmount, setTotalAmount] = useState(0);

	useEffect(() => {
		if (data && isOpen) {
			setSelectedAmounts([]);
			setSelectedIds([]);
			setTotalAmount(0);
		}
	}, [data, isOpen]);

	// Update the handler to accept the id parameter as well.
	const handleCheckboxChange = (amount, id, isChecked) => {
		const numericAmount = parseFloat(amount) || 0;

		if (isChecked) {
			setSelectedAmounts((prev) => [...prev, numericAmount]);
			setSelectedIds((prev) => [...prev, id]);
			setTotalAmount((prev) => prev + numericAmount);
		} else {
			setSelectedAmounts((prev) => prev.filter((a) => a !== numericAmount));
			setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
			setTotalAmount((prev) => prev - numericAmount);
		}
	};

	// Calculate the remaining amount
	const remainingAmount = Math.max(0, billAmount - Math.abs(totalAmount));

	const isSelectionDisabled = totalAmount >= billAmount;
	return (
		<Modal
			isOpen={isOpen}
			onClose={() => {
				onClose();
				setSelectedAmounts([]); // Reset selected amounts
				setSelectedIds([]); // Reset selected IDs
				setTotalAmount(0); // Reset total amount
			}}
			className={`relative bg-white pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
			aria-labelledby="modal-title"
		>
			<span id="modal-title" className="flex text-2xl text-green-500">
				{title}
			</span>

			<ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
				{data && data.length > 0 ? (
					<div className="overflow-x-auto mt-4">
						<table className="table-auto w-full border-collapse border border-gray-500">
							<thead>
								<tr className="bg-gray-200">
									<th className="border border-gray-500 px-4 py-2">Choose</th>

									<th className="border border-gray-500 px-4 py-2">
										Start Date
									</th>

									<th className="border border-gray-500 px-4 py-2">
										Reference No
									</th>
									<th className="border border-gray-500 px-4 py-2">
										Adjusted Amount
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index} className="hover:bg-gray-100">
										<td className="border border-gray-500 px-4 py-2">
											<input
												type="checkbox"
												onChange={(e) =>
													handleCheckboxChange(
														item.bill_adjusted_amount,
														item.id,
														e.target.checked
													)
												}
												disabled={
													isSelectionDisabled && !selectedIds.includes(item.id)
												}
											/>
										</td>

										<td className="border border-gray-500 px-4 py-2">
											{item.va_start_date
												? new Date(item.va_start_date).toLocaleDateString()
												: 'N/A'}
										</td>

										<td className="border border-gray-500 px-4 py-2">
											{item.ref_no || 'N/A'}
										</td>
										<td className="border border-gray-500 px-4 py-2">
											{item.bill_adjusted_amount || 'N/A'}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : (
					<p className="text-gray-500 mt-4"></p>
				)}
				{isSelectionDisabled && (
					<p className="text-red-500 mt-4">
						Maximum allowed amount reached. Uncheck items to make changes.
					</p>
				)}
				<div className="mt-4 flex space-x-4">
					{/* Bill Amount Input Box */}
					<div className="flex-1">
						<label htmlFor="billAmount" className="block text-gray-700">
							Payable Amount
						</label>
						<input
							id="billAmount"
							type="text"
							autoComplete="off"
							value={billAmount}
							readOnly
							className="input w-full border border-gray-500 rounded-md p-2 mt-2"
						/>
					</div>

					{/* Adjusted Amount Input Box */}
					<div className="flex-1">
						<label htmlFor="totalAmount" className="block text-gray-700">
							Adjusted Amount
						</label>
						<input
							id="totalAmount"
							type="text"
							autoComplete="off"
							value={Math.abs(totalAmount)}
							readOnly
							className="input w-full border border-gray-500 rounded-md p-2 mt-2"
						/>
					</div>

					{/* Remaining Amount Input Box */}
					<div className="flex-1">
						<label htmlFor="remainingAmount" className="block text-gray-700">
							Remaining Payable Amount
						</label>
						<input
							id="remainingAmount"
							type="text"
							autoComplete="off"
							value={remainingAmount}
							readOnly
							className="input w-full border border-gray-500 rounded-md p-2 mt-2"
						/>
					</div>
				</div>
				<div className="flex flex-col flex-1">
					<LabelArea label="Remark" />
					<Input
						className={`border h-10 text-sm block w-full focus:bg-white`}
						type="text"
						name="remark"
						placeholder="Enter remark"
						value={remarks}
						onChange={(e) => setRemarks(e.target.value)}
					/>
				</div>

				<div className="modal-actions flex justify-around space-x-4 mt-4">
					<button
						onClick={onClose}
						className="btn btn-secondary px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
					>
						Cancel
					</button>
					<button
						onClick={() =>
							handleSubmit(selectedIds, billAmount, remarks, totalAmount)
						}
						className="btn btn-primary px-4 py-2 bg-green-500 text-white rounded-md"
					>
						Submit
					</button>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default BillApprovalDetails;
